import {createAction} from '@reduxjs/toolkit'
import {MembersModal, ModalResponse} from '@wix/wix-events-commons-statics'
import {callAPI, createActions} from '../../../../commons/actions/data-action-helper'
import {getLanguage} from '../../../../commons/selectors/environment'
import {openModal, openModalOld} from '../../../../commons/services/modal'
import {getRealEvents} from '../selectors/events'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetState, StoreExtraArgs} from '../types/state'

export const PROMPT_LOGIN_OLD = createActions('PROMPT_LOGIN_OLD')
export const LOAD_MEMBERS_FOR_EVENTS_OLD = createActions('LOAD_MEMBERS_FOR_EVENTS_OLD')
export const MEMBER_LOGGED_IN = 'MEMBER_LOGGED_IN'

export const ensureLoggedInOld =
  () =>
  async (dispatch, _getState: GetState, {wixCodeApi}: StoreExtraArgs) => {
    if (!wixCodeApi.user.currentUser.loggedIn) {
      return dispatch(promptLoginOld())
    }
    return true
  }

export const ensureLoggedIn = createAsyncAction<boolean, void>(
  'ENSURE_LOGGED_IN',
  async (_, {dispatch, extra: {wixCodeApi}}) =>
    !wixCodeApi.user.currentUser.loggedIn ? dispatch(promptLogin()).unwrap() : true,
)

export const promptLoginOld = () => (dispatch, getState: GetState) =>
  dispatch(callAPI(PROMPT_LOGIN_OLD, getLanguage(getState())))

export const promptLogin = createAsyncAction<boolean, void>('PROMPT_LOGIN', async (_, {getState, extra: {serverApi}}) =>
  serverApi.promptLogin(getLanguage(getState())),
)

export const loadMembersForEventsOld = () => (dispatch, getState: GetState) =>
  dispatch(
    callAPI(
      LOAD_MEMBERS_FOR_EVENTS_OLD,
      getRealEvents(getState()).map(event => event.id),
    ),
  )

export const loadMembersForEvents = createAsyncAction<GuestLists>(
  'LOAD_MEMBERS_FOR_EVENTS',
  async (_, {getState, extra: {serverApi}}) =>
    serverApi.getGuestLists(getRealEvents(getState()).map(event => event.id)),
)

export const openMembersModalOld = (eventId: string) => async (dispatch: Function) => {
  const loggedIn = await dispatch(ensureLoggedInOld())
  if (loggedIn) {
    return dispatch(
      openModalOld({
        type: MembersModal.LIST,
        params: {
          eventId,
        },
      }),
    )
  }
}

export const openMembersModal = createAsyncAction<ModalResponse, string>(
  'OPEN_MEMBERS_MODAL',
  async (eventId, {dispatch}) => {
    const loggedIn = await dispatch(ensureLoggedIn()).unwrap()
    if (loggedIn) {
      return dispatch(openModal({type: MembersModal.LIST, params: {eventId}})).unwrap()
    }
  },
)

export const addLoginListenerOld =
  () =>
  async (dispatch: Function, _getState: GetState, {wixCodeApi}: StoreExtraArgs) => {
    wixCodeApi.user.onLogin(async user => {
      if (user.loggedIn) {
        dispatch(memberLoggedIn())
      }
    })
  }

export const memberLoggedIn = createAction('MEMBER_LOGGED_IN')
